type Tab<T extends string> = { id: T; disabled?: boolean };
export function tabStop<T extends string>(items: readonly Tab<T>[], value: T): T | undefined {
  return items.find(item => item.id === value && !item.disabled)?.id ?? items.find(item => !item.disabled)?.id;
}
export function nextTab<T extends string>(items: readonly Tab<T>[], current: T, key: string): T | undefined {
  if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(key)) return;
  const enabled = items.filter(item => !item.disabled);
  if (!enabled.length) return;
  if (key === "Home") return enabled[0].id;
  if (key === "End") return enabled.at(-1)!.id;
  const index = enabled.findIndex(item => item.id === current);
  if (index < 0) return (key === "ArrowLeft" ? enabled.at(-1)! : enabled[0]).id;
  return enabled[(index + (key === "ArrowLeft" ? -1 : 1) + enabled.length) % enabled.length].id;
}
